<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <feather-icon
            icon="MenuIcon"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div class="align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- <div>
        <div ref="pageTitle">
          {{ $route.meta.pageTitle }}
        </div>
        <b-breadcrumb class="py-0 pl-0">
          <b-breadcrumb-item to="/">
            Home
          </b-breadcrumb-item>
          <b-breadcrumb-item
            v-for="item in $route.meta.breadcrumb"
            :key="item.text"
            :active="item.active"
            :to="item.to"
          >
            {{ item.text }}
          </b-breadcrumb-item>
        </b-breadcrumb>
      </div> -->

      <Breadcrumbs :key="changedBreadcrumbs" />
    </div>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <notification-dropdown v-if="!adminPlatform" />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
// import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import { mapGetters } from 'vuex'
import NotificationDropdown from './components/NotificationDropdown.vue'
import UserDropdown from './components/UserDropdown.vue'

export default {
  components: {
    // Navbar Components
    // Bookmarks,
    // SearchBar,
    // DarkToggler,
    // CartDropdown,
    NotificationDropdown,
    UserDropdown,
    // GjIcon,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('verticalMenu', ['adminPlatform', 'changedBreadcrumbs']),
  },
}
</script>
